



























import { Vue, Component, Prop } from 'vue-property-decorator';
import Staff from '@/services/Staff';
import { State } from 'vuex-class';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';

import { Organization } from '@/common/Organizations';
import { update } from '../../../services/Downloads';

@Component({
	name: 'PolicyManagement',
	components: {
		Loading,
		Alert,
	},
})
export default class PolicyManagement extends Vue {
	@Prop() private policyData;
	private newOrgId: string = '';
	private mainClientId: string = '';
	private loading: boolean = true;
	private updateOrgSuccess: boolean = false;

	@State('organizations', { namespace: 'Organizations' })
	private organizations: Organization[] = undefined;

	get organizationList() {
		return this.organizations
			.filter(org => org.org_name !== undefined)
			.map(org => {
				if (org.is_agency === true) {
					org.org_name = org.org_name.replace(/\(Agency\)/, '').trim() + ' (Agency)';
				}
				return {
					org_id: org.org_id,
					org_name: org.org_name,
				};
			});
	}

	private async changeOrg() {
		try {
			this.updateOrgSuccess = false;
			const getMainRisk = Object.values(this.policyData.risks).filter(
				// @ts-ignore
				p => p.main_risk === 'Y',
			);

			const updatePolicy = await Staff.updatePolicy({
				cmd: 'changeOrg',
				product_ids: [this.policyData.product_id],
				new_org_id: this.newOrgId,
				// @ts-ignore
				main_client_id: getMainRisk[0].client_id,
			});
			this.policyData.org_id = this.newOrgId;
			this.$emit('update:policyData', this.policyData);

			console.log(updatePolicy);
			this.updateOrgSuccess = true;
		} catch (e) {
			console.log(e);
		}
	}

	private async created() {
		try {
			await this.$store.dispatch('Organizations/getOrganizations');
			this.newOrgId = this.policyData.org_id;
		} catch (e) {
			console.log(e);
		} finally {
			this.loading = false;
		}
	}

	private updateOrg(value) {
		this.newOrgId = value;
	}
}
